<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_operator(
          @click="onClickWrapper($event)"
        )
          .modal__close
            button.modal-button-close(
              @click="onCloseModal()"
            )
              img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            operator-accept(
              v-if="content === 'operator-accept'"
              :on-submit-modal="onSubmitModal"
              :on-close-modal="onCloseModal"
            )
            operator-reject(
              v-else-if="content === 'operator-reject'"
              :on-submit-modal="onSubmitModal"
              :on-close-modal="onCloseModal"
            )
            operator-reject-docs(
              v-else-if="content === 'operator-reject-docs'"
              :on-submit-modal="onSubmitModal"
              :on-close-modal="onCloseModal"
            )
</template>

<script>
import OperatorAccept from "./components/OperatorAccept";
import OperatorReject from "./components/OperatorReject";
import OperatorRejectDocs from "./components/OperatorRejectDocs";
export default {
  name: "OperatorModal",
  components: {OperatorRejectDocs, OperatorReject, OperatorAccept},
  props: ["content", "onSubmitModal"],
  data() {
    return {
      modalType: "",
      accessHeader: {
        title: "",
        text: ""
      }
    };
  },
  methods: {
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    }
  }
};
</script>
